const parseUuids = uuids => {
  const parsedUuids = uuids.map(uuid => `"${uuid}"`);

  if (uuids.length > 1) {
    return `[${parsedUuids.join(', ')}]`;
  }

  return `[${parsedUuids}]`;
};

export const encodeUuids = uuids => {
  return encodeURIComponent(parseUuids(uuids));
};
